var _rect, _g, _rect2, _g2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 193,
    viewBox: "0 0 442 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 374,
    height: 109
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 374,
    height: 109,
    fill: "#1E1E1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1 193C12.66 193 11.31 192.46 10.05 191.38C8.97 190.12 8.43 188.77 8.43 187.33C8.43 186.43 8.52 185.62 8.7 184.9L72.15 11.56C72.69 9.57999 73.77 7.86999 75.39 6.42999C77.19 4.80999 79.62 3.99999 82.68 3.99999H122.64C125.7 3.99999 128.04 4.80999 129.66 6.42999C131.46 7.86999 132.63 9.57999 133.17 11.56L196.35 184.9C196.71 185.62 196.89 186.43 196.89 187.33C196.89 188.77 196.26 190.12 195 191.38C193.92 192.46 192.57 193 190.95 193H157.74C155.04 193 152.97 192.37 151.53 191.11C150.27 189.67 149.46 188.41 149.1 187.33L138.57 159.79H66.48L56.22 187.33C55.86 188.41 55.05 189.67 53.79 191.11C52.53 192.37 50.37 193 47.31 193H14.1ZM77.55 120.91H127.77L102.39 49.63L77.55 120.91ZM238.421 193C236.441 193 234.821 192.37 233.561 191.11C232.301 189.85 231.671 188.23 231.671 186.25V10.75C231.671 8.76999 232.301 7.14999 233.561 5.88999C234.821 4.62999 236.441 3.99999 238.421 3.99999H274.061C275.861 3.99999 277.391 4.62999 278.651 5.88999C280.091 7.14999 280.811 8.76999 280.811 10.75V152.23H362.351C364.331 152.23 365.951 152.95 367.211 154.39C368.651 155.65 369.371 157.27 369.371 159.25V186.25C369.371 188.23 368.651 189.85 367.211 191.11C365.951 192.37 364.331 193 362.351 193H238.421Z",
    fill: "#5E5C7F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_27_136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 131,
    width: 368,
    height: 62
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 131,
    width: 368,
    height: 62,
    fill: "#1E1E1E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_27_136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1 193C12.66 193 11.31 192.46 10.05 191.38C8.97 190.12 8.43 188.77 8.43 187.33C8.43 186.43 8.52 185.62 8.7 184.9L72.15 11.56C72.69 9.57999 73.77 7.86999 75.39 6.42999C77.19 4.80999 79.62 3.99999 82.68 3.99999H122.64C125.7 3.99999 128.04 4.80999 129.66 6.42999C131.46 7.86999 132.63 9.57999 133.17 11.56L196.35 184.9C196.71 185.62 196.89 186.43 196.89 187.33C196.89 188.77 196.26 190.12 195 191.38C193.92 192.46 192.57 193 190.95 193H157.74C155.04 193 152.97 192.37 151.53 191.11C150.27 189.67 149.46 188.41 149.1 187.33L138.57 159.79H66.48L56.22 187.33C55.86 188.41 55.05 189.67 53.79 191.11C52.53 192.37 50.37 193 47.31 193H14.1ZM77.55 120.91H127.77L102.39 49.63L77.55 120.91ZM238.421 193C236.441 193 234.821 192.37 233.561 191.11C232.301 189.85 231.671 188.23 231.671 186.25V10.75C231.671 8.76999 232.301 7.14999 233.561 5.88999C234.821 4.62999 236.441 3.99999 238.421 3.99999H274.061C275.861 3.99999 277.391 4.62999 278.651 5.88999C280.091 7.14999 280.811 8.76999 280.811 10.75V152.23H362.351C364.331 152.23 365.951 152.95 367.211 154.39C368.651 155.65 369.371 157.27 369.371 159.25V186.25C369.371 188.23 368.651 189.85 367.211 191.11C365.951 192.37 364.331 193 362.351 193H238.421Z",
    fill: "#5E5C7F"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 152,
    width: 42,
    height: 41,
    rx: 10,
    fill: "#FF4C61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAl);
export default __webpack_public_path__ + "static/media/AL.b9cbd96cf917b9a455171da509491828.svg";
export { ForwardRef as ReactComponent };